import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Dictionary} from 'src/app/shared/data.service';
import {Language} from '../../features/user/user.data.service';

export interface LanguageDialogData {
  currentLanguage: Language;
  languageMapping: Dictionary<string, Language>;
}

@Component({
  selector: 'app-language-dialog',
  templateUrl: './language-dialog.component.html',
  styleUrls: ['./language-dialog.component.scss'],
})
export class LanguageDialogComponent {
  dialogData: LanguageDialogData;

  constructor(
    @Inject(MAT_DIALOG_DATA) private readonly _data: LanguageDialogData,
    private readonly _dialogRef: MatDialogRef<LanguageDialogComponent>,
  ) {
    this.dialogData = this._data;
  }

  handleSave(): void {
    this._dialogRef.close(this.dialogData.currentLanguage);
  }

  handleCancel(): void {
    this._dialogRef.close();
  }
}
